import { digitalWarehouseBlockedReasons } from "@redotech/redo-shopify-settings-common/shopify-extension-settings";
import * as z from "zod";

export const updateDigitalWarehouseSetting = {
  name: "updateDigitalWarehouseSetting" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({
    outcome: z.enum(["saved", "rejected", "check_failed"]),
    enabled: z.boolean(),
    blockedReason: z.enum(digitalWarehouseBlockedReasons).optional(),
    checkedAt: z.date().optional(),
  }),
};
